var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner border-l-transparent",class:[_vm.sizeClass, _vm.borderClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }